import { Box, Typography, Paper } from "@mui/material";
import React from "react";
import VideoSection from "./VideoSection";
import { useTranslation } from "react-i18next";

export default function Videos(props) {
  const { videosWatched, videos, finishVideo, videoQuestions } = props;

  const { t } = useTranslation();

  const renderVideoSections = () => {
    const sections = [];

    let videoToFinish;

    for (let video of videos) {
      const done = Boolean(videosWatched.find((value) => value === video.id));
      const videoQuestion = videoQuestions.find(v => v.videoId === video.id);
      sections.push(
        <VideoSection
          key={video.id}
          done={done}
          finishVideo={() => finishVideo(video.id)}
          videoToFinish={videoToFinish}
          video={video}
          videoQuestion={videoQuestion}
        />
      );
    }

    return sections;
  };

  return (
    <Box
      sx={{
        m: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Paper sx={{mb: 2, mt: 4, p: 1}}>
        <Typography variant="h1" align="center" sx={{ m: 0 }}>
          {t("videoHeader")}
        </Typography>
      </Paper>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          flexWrap: "wrap",
        }}
      >
        {renderVideoSections()}
      </Box>
    </Box>
  );
}
